import { useEffect, useRef } from 'react';

const STALE_THRESHOLD_MS = 30_000; // 30 seconds

/**
 * Calls `onRefresh` when the browser tab regains focus after being
 * hidden for longer than STALE_THRESHOLD_MS.
 */
export default function useRefreshOnFocus(onRefresh) {
  const hiddenAt = useRef(null);

  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === 'hidden') {
        hiddenAt.current = Date.now();
      } else if (document.visibilityState === 'visible' && hiddenAt.current) {
        const elapsed = Date.now() - hiddenAt.current;
        hiddenAt.current = null;
        if (elapsed >= STALE_THRESHOLD_MS) {
          onRefresh();
        }
      }
    };

    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, [onRefresh]);
}
